import anpdContactList from './anpdContactList'
import churnList from './churnList'
import clientProfileList from './clientProfileList'
import collaboratorList from './collaboratorList'
import collaboratorProfileList from './collaboratorProfileList'
import companyList from './companyList'
import companySizeList from './companySizeList'
import companySupplierList from './companySupplierList'
import couponList from './couponList'
import dataProcessList from './dataProcessList'
import departmentList from './departmentList'
import documentationLinkList from './documentationLinkList'
import documentTemplateList from './documentTemplateList'
import economicActivityList from './economicActivityList'
import exportInfoList from './exportInfoList'
import exportRipdList from './exportRipdList'
import faqsDocumentationList from './faqsDocumentationList'
import formOptionList from './formOptionList'
import groupList from './groupList'
import incidentList from './incidentList'
import lastUpdatesList from './lastUpdateList'
import legalFrameworkList from './legalFrameworkList'
import organizationList from './organizationList'
import paymentContractList from './paymentContractList'
import paymentOrdersList from './paymentOrdersList'
import planList from './planList'
import preRegistrationList from './preRegistrationList'
import privacyPolicyList from './privacyPolicyList'
import questionnaireByCompanyList from './questionnaireByCompanyList'
import rmcListingList from './rmcListingList'
import rmcResumeList from './rmcResumeList'
import segmentList from './segmentList'
import sellerList from './sellerList'
import ssoCorporateGroupList from './ssoCoporateGroupList'
import subgroupList from './subgroupList'
import userList from './userList'

const collaboratorProfileLists = {
  anpdContactList,
  churnList,
  clientProfileList,
  collaboratorList,
  collaboratorProfileList,
  companyList,
  companySizeList,
  companySupplierList,
  couponList,
  dataProcessList,
  departmentList,
  documentationLinkList,
  documentTemplateList,
  economicActivityList,
  exportInfoList,
  exportRipdList,
  faqsDocumentationList,
  formOptionList,
  groupList,
  incidentList,
  lastUpdatesList,
  legalFrameworkList,
  organizationList,
  paymentContractList,
  paymentOrdersList,
  planList,
  preRegistrationList,
  privacyPolicyList,
  questionnaireByCompanyList,
  rmcListingList,
  rmcResumeList,
  segmentList,
  sellerList,
  ssoCorporateGroupList,
  subgroupList,
  userList,
}

export default collaboratorProfileLists
